<script lang="ts" setup>
import { computed } from 'vue';
import Qs from 'qs';
import { NotificationGroupMarkType } from '@/types';
import CardTemplate from './card-template.vue';

// WARN: 通知の表記を変更するときは serviceWorkerHelper.ts の変更漏れがないかも確認する
// WARN: 通知のURLを変更するときは web-push.vue の変更漏れがないかも確認する

interface Props {
  notification: NotificationGroupMarkType;
  isUnread: boolean;
}

const props = defineProps<Props>();

const url = computed(() => {
  const params = {
    doc_type: props.notification.document.doc_type,
    document_id: props.notification.document.id,
    article_lang:
      props.notification.document.doc_type === 'patent'
        ? props.notification.document.lang
        : undefined,
    patent_publication_office:
      props.notification.document.patent_publication_office ?? undefined,
    report_page_number:
      props.notification.document.report_page_number ?? undefined,
  };
  return `/groups/${props.notification.group.id}/marks?${Qs.stringify(params)}`;
});
</script>
<template>
  <CardTemplate
    :type="notification.type"
    :url="url"
    :is-unread="isUnread"
    :created-at="notification.created_at"
    :user-id="notification.creator_id"
    :image-url="notification.creator_image_url"
    :content-title="notification.document.title"
    :group-name="notification.group.name"
  >
    グループに新しいグループマークがあります。
  </CardTemplate>
</template>
